/**
 * Truncates a given string to a given word count.
 *
 * @param {number} wordCount The number of words to truncate the string to.
 * @param {string} content The content string to truncate.
 * @returns {string} The truncated string.
 * @throws {Error} If wordCount is not a positive integer, or if content is not a non-empty string.
 */

export const truncateString = (wordCount: number, content: string): string => {
  if (!Number.isInteger(wordCount) || wordCount <= 0) {
    throw new Error('wordCount must be a positive integer');
  }

  if (!content || typeof content !== 'string' || !content.trim()) {
    throw new Error('content must be a non-empty string');
  }

  const trimmed = content.trim();

  if (!trimmed) {
    return '';
  }

  const quickWordCount = trimmed.split(/\s+/).length;

  if (quickWordCount <= wordCount) {
    return content;
  }

  const words = trimmed.match(/\S+(?:\s+|$)/g);

  if (!words || words.length <= wordCount) {
    return content;
  }

  return `${words.slice(0, wordCount).join('').trimEnd()} ... `;
};
